import EmblaCarousel from 'embla-carousel'
import { addPrevNextBtnsClickHandlers } from './modules/embla-arrow-buttons.js'
import * as CookieConsent from "vanilla-cookieconsent";


const initPlikisGlobals = () => {

    function catalogFilter() {
        // Get the filter input element
        var filterInput = document.getElementById('catalog-filter-input');
        if (!filterInput) return;
        // Listen for changes on the filter input
        filterInput.addEventListener('input', function () {
            // Get the value of the filter input
            var filterValue = this.value.toLowerCase();

            if (filterValue === '') {
                //show all
                var catalogLinks = document.querySelectorAll('.catalog-tree .search-tree-card a');
                catalogLinks.forEach(function (link) {
                    link.classList.remove('d-none');
                    if (link.closest('.children')) {
                        link.closest('.list-group-item').classList.remove('d-none');
                    }
                });
                var searchTreeCards = document.querySelectorAll('.search-tree-card');
                searchTreeCards.forEach(function (searchTreeCard) {
                    searchTreeCard.classList.remove('d-none');
                });
                return;
            }

            // Get all "a" elements within ".catalog-tree"
            var catalogLinks = document.querySelectorAll('.catalog-tree .search-tree-card a');

            // Loop through all "a" elements
            catalogLinks.forEach(function (link) {
                var linkText = link.textContent.toLowerCase();

                // If the link text contains the filter value
                if (linkText.includes(filterValue)) {
                    // Show the link and its parent if it's under a ".children" element
                    link.classList.remove('d-none');
                    if (link.closest('.children')) {
                        link.closest('.list-group-item').classList.remove('d-none');
                    }
                } else {
                    // Hide the link
                    link.classList.add('d-none');
                    if (link.closest('.children')) {
                        link.closest('.list-group-item').classList.add('d-none');
                    }
                }
            });

            //loop all ".search-tree-card" elements. If all children are hidden, hide the parent. If all children are visible, show the parent.
            var searchTreeCards = document.querySelectorAll('.search-tree-card');
            searchTreeCards.forEach(function (searchTreeCard) {
                var children = searchTreeCard.querySelectorAll('.children .list-group-item');
                var hiddenChildren = searchTreeCard.querySelectorAll('.children .list-group-item.d-none');
                if (children.length === hiddenChildren.length) {
                    searchTreeCard.classList.add('d-none');
                    searchTreeCard.classList.add('addedsecondtime');
                } else {
                    searchTreeCard.classList.remove('d-none');
                }

                //if any children is visible, show the parent
                var visibleChildren = searchTreeCard.querySelectorAll('.children .list-group-item:not(.d-none)');
                if (visibleChildren.length > 0) {
                    searchTreeCard.classList.remove('d-none');
                    searchTreeCard.classList.remove('addedsecondtime');
                    searchTreeCard.querySelector('.parent a').classList.remove('d-none');
                }
            });

        });
    }

    function watchPlToggle() {
        var plToggle = document.querySelectorAll('[data-toggle-card-children]');
        if (!plToggle) return;
        plToggle.forEach(function (toggle) {
            toggle.addEventListener('click', function () {
                var plId = this.getAttribute('data-pl-toggle');
                var parentChildren = this.closest('.search-tree-card').querySelectorAll('.children .toggable');
                //toggle d-none on all children
                parentChildren.forEach(function (child) {
                    child.classList.toggle('d-none');
                });

                this.classList.toggle('expanded');
                this.blur();
                return true;
            });
        });
    }

    function initHeaderCategoriesSlider() {
        const sliderNode = document.querySelector('.top-categories-slider');
        const emblaNode = document.querySelector('.top-categories-slider .embla');
        if(!sliderNode || !emblaNode) return;
        const options = { dragFree: true, containScroll: 'trimSnaps' }
        const viewportNode = emblaNode.querySelector('.embla__viewport')

        const emblaApi = EmblaCarousel(viewportNode, options)

        const prevBtn = sliderNode.querySelector('.embla__button--prev');
        const nextBtn = sliderNode.querySelector('.embla__button--next');

        const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
            emblaApi,
            prevBtn,
            nextBtn
        )

        emblaApi.on('destroy', removePrevNextBtnsClickHandlers)

    }
    
    function openOffcanvasCategoriesMenu(){
        //listen for click on [data-opencategoriessubmenu]
        var openCategoriesMenu = document.querySelectorAll('[data-opencategoriessubmenu]');
        if (!openCategoriesMenu) return;
        openCategoriesMenu.forEach(function (opener) {
            opener.addEventListener('click', function () {
                var target = this.getAttribute('data-bs-target');
                //trim the # from the target
                target = target.replace('#', '');
                var targetNode = document.getElementById(target);
                console.log(targetNode);
                if (targetNode) {
                    
                    //find menu__list in targetNode, then first element with .menu--childrens class. Click on .js-menu-open-child inside it
                    var menuList = targetNode.querySelector('.menu__list');
                    var firstChildren = menuList.querySelector('.menu--childrens');
                    var openChild = firstChildren.querySelector('.js-menu-open-child');
                    openChild.click(); 
                }
            });
        });
    }

    function offCanvasMenuOpenSubCategories(){
        //on li#category-2 a click inside #mobileMenu trigger click event on its .js-menu-open-child
        const mobileMenu = document.querySelector("#mobileMenu");
        if (!mobileMenu) return;
        const category2 = mobileMenu.querySelector("li#category-2 a");
        if (!category2) return;
        //rename from "Pagrindinis" to "Kategorijos"
        category2.textContent = "Kategorijos";
        category2.addEventListener('click', function(e){
            e.preventDefault();
            mobileMenu.querySelector("li#category-2 .js-menu-open-child").click();
        });
    }
    
    function fixCheckoutIssues(){
        if(document.body.id !== 'checkout') return;
        if( !window.prestashop) return;
        window.prestashop.on('thecheckout_updateDeliveryOption', function () {
            
            // Hide all carrier extra content
            var allExtraContent = document.querySelectorAll(".carrier-extra-content");
            allExtraContent.forEach(function (content) {
                content.style.display = 'none';
            });
            document.querySelector(".delivery-option-row.selected + .carrier-extra-content").style.display = 'block';
            // Add your custom logic here to handle the event
        });
    }
    
    function renderOemNumbers() {
        // Check if the element with id 'single-product-oem-numbers-placeholder' exists
        var oemNumbersPlaceholder = document.getElementById('single-product-oem-numbers-placeholder');
        if (!oemNumbersPlaceholder) return;
        
        // Get the OEM URL from the data attribute
        var oemUrl = oemNumbersPlaceholder.getAttribute('data-oemurl');
        if (!oemUrl) return;

        // Fetch the OEM numbers from the URL
        fetch(oemUrl)
        .then(response => {
            // When the page is loaded convert it to text
            return response.text()
          })
          .then(html => {
            
            if(!html || html.trim() === '') {
                oemNumbersPlaceholder.classList.add('d-none');
                return;
            }
            oemNumbersPlaceholder.innerHTML = html;
            oemNumbersPlaceholder.classList.remove('d-none');
            
            //if table inside oemNumbersPlaceholder has more than 15 rows, make it expandable
            var oemTable = oemNumbersPlaceholder.querySelector('table');
            var tableWrapper = oemNumbersPlaceholder.querySelector('.product-info-text');
            if(oemTable) {
                var oemTableRows = oemTable.querySelectorAll('tbody tr');
                if (oemTable.offsetHeight > 400) {
                    var savedTabbleHeight = oemTable.offsetHeight;
                    tableWrapper.classList.add('expandable-oem-table');
                    tableWrapper.dataset.originalHeight = savedTabbleHeight;
                    //add expand button
                    var expandButton = document.createElement('button');
                    expandButton.className = 'expand-oem-table-btn btn btn-link mt-2 d-block mx-auto py-1';
                    // Create SVG element for arrow
                    const arrowSvg = document.createElement('span');
                    arrowSvg.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
                        <path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z"></path>
                    </svg>`;
                    arrowSvg.style.verticalAlign = 'middle';
                    arrowSvg.style.marginLeft = '4px';
                    arrowSvg.style.display = 'inline-block';

                    expandButton.textContent = 'Rodyti daugiau';
                    expandButton.appendChild(arrowSvg);

                    expandButton.addEventListener('click', function () {
                        tableWrapper.classList.toggle('expanded');
                        if(tableWrapper.classList.contains('expanded')) {
                            expandButton.textContent = 'Rodyti mažiau';
                            // Rotate arrow up
                            arrowSvg.style.transform = 'rotate(180deg)';
                        } else {
                            expandButton.textContent = 'Rodyti daugiau';
                            // Rotate arrow down
                            arrowSvg.style.transform = 'rotate(0deg)';
                        }
                        expandButton.appendChild(arrowSvg);
                    });
                    oemNumbersPlaceholder.appendChild(expandButton);
                }
            }
            
          })
          .catch(error => {
            console.error('Error fetching OEM numbers:', error);
          });
            
    }
    
    function renderTecdocCrossReferences(){
        // Check if the element with id 'product-tec-cross-references' exists
        var crossRefPlaceholder = document.getElementById('product-tec-cross-references');
        if (!crossRefPlaceholder) return;
        
        // Get the cross reference URL from the data attribute
        var crossRefUrl = crossRefPlaceholder.getAttribute('data-crossrefurl');
        if (!crossRefUrl) return;
        
        // Fetch the cross references from the URL
        fetch(crossRefUrl)
        .then(response => {
            // When the page is loaded convert it to text
            if(!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then(response => {
            let html = response.html;
            if(!html || html.trim() === '') {
                crossRefPlaceholder.classList.add('d-none');
                return;
            }
            crossRefPlaceholder.innerHTML = html;
            crossRefPlaceholder.classList.remove('d-none');
            
          })
          .catch(error => {
            console.error('Error fetching cross references:', error);
          });
            
    }
    
    function onSearchShowLoader() {
        let loader = document.querySelector('.page-loader');
        if (!loader) return;
        let searchForm = document.querySelector('#search_widget form');
        if (!searchForm) return;
        
        searchForm.addEventListener('submit', function () {
            // Show the loader
            loader.classList.remove('d-none');
        });
        
    }
    
    function searchTypeToggle() {
        let searchTypeRadios = document.querySelectorAll('input[name="searchType"]');
        if (!searchTypeRadios) return;

        searchTypeRadios.forEach(function (radio) {
            radio.addEventListener('change', function () {
                let loader = document.querySelector('.page-loader');
                if (loader) {
                    loader.classList.remove('d-none');
                }

                let selectedType = this.value;
                let currentUrl = new URL(window.location.href);

                // Update or add the 'type' parameter
                currentUrl.searchParams.set('type', selectedType);

                // Redirect to the updated URL
                window.location.href = currentUrl.toString();
            });
        });
    }
    
    function initCriteriaExpand(){

        const tableContainer = document.querySelectorAll('.list-criteria-table-container');
        
        if (!tableContainer || tableContainer.length === 0) return;
        
        // Add expand button to each table container
        tableContainer.forEach(container => {
            const expandButton = container.querySelector('.expand-table-btn');
            if (!expandButton) {
                const newExpandButton = document.createElement('button');
                newExpandButton.className = 'expand-table-btn';
                newExpandButton.textContent = 'Expand';
                newExpandButton.style.display = 'none'; // Initially hidden
                newExpandButton.addEventListener('click', function () {
                    toggleCriteriaTableHeight(this);
                });
                container.appendChild(newExpandButton);
            }
            
            //on button click, toggle the height of the table
            if (expandButton) {
                expandButton.addEventListener('click', function () {
                    toggleCriteriaTableHeight(this);
                });
            }
            
            // Check if the table is scrollable and show the button if it is
            const table = container.querySelector('.table');
            if (table && table.scrollHeight > 300) {
                expandButton.style.display = 'block';
            } else {
                expandButton.style.display = 'none';
            }
        });

            
        
        
        
    }
    
    initCriteriaExpand();
    
    function toggleCriteriaTableHeight(button) {
        const tableContainer = button.parentElement;
        if (!tableContainer) return;
        if (tableContainer.classList.contains('expanded')) {
            tableContainer.classList.remove('expanded');
            button.classList.remove('expanded');
        } else {
            tableContainer.classList.add('expanded');
            button.classList.add('expanded');
        }
    }
    
    
    function initCookieConsent(){
        CookieConsent.run({
            guiOptions: {
                consentModal: {
                    layout: "box",
                    position: "bottom left",
                    equalWeightButtons: true,
                    flipButtons: false
                },
                preferencesModal: {
                    layout: "box",
                    position: "right",
                    equalWeightButtons: true,
                    flipButtons: false
                }
            },
            categories: {
                necessary: {
                    readOnly: true
                },
                functionality: {},
                analytics: {}
            },
            language: {
                default: "en",
                autoDetect: "browser",
                translations: {
                    en: {
                        consentModal: {
                            title: "Mūsų svetainė naudoja sausainiukus",
                            description: "Naudojame sausainiukus (cookies) siekiant užtikrinti sklandų svetainės darbą. ",
                            closeIconLabel: "",
                            acceptAllBtn: "Priimti visus",
                            acceptNecessaryBtn: "Atmesti visus",
                            showPreferencesBtn: "Valdyti pasirinkimus",
                            footer: "<a href=\"/privatumo-politika\">Privatumo politika</a>"
                        },
                        preferencesModal: {
                            title: "Pasirinkimų valdymas",
                            closeIconLabel: "Uždaryti",
                            acceptAllBtn: "Priimti visus",
                            acceptNecessaryBtn: "Atmesti visus",
                            savePreferencesBtn: "Išsaugoti",
                            serviceCounterLabel: "Paslauga",
                            sections: [
                                {
                                    title: "Sausainiukų naudojimo tikslai",
                                    description: "Šioje svetainėje naudojame sausainiukus, kad galėtume teikti jums geresnę paslaugą. Paspaudę „Priimti visus“, sutinkate su mūsų sausainiukų politika.",
                                },
                                {
                                    title: "Būtini sausainiukai",
                                    description: "",
                                    linkedCategory: "necessary"
                                },
                                {
                                    title: "Funkcionalumo sausainiukai",
                                    description: "",
                                    linkedCategory: "functionality"
                                },
                                {
                                    title: "Analitikos sausainiukai",
                                    description: "",
                                    linkedCategory: "analytics"
                                },
                                {
                                    title: "Daugiau informacijos",
                                    description: "Daugiau informacijos apie tai, kaip mes naudojame sausainiukus, galite rasti mūsų <a class=\"cc__link\" href=\"/privatumo-politika\">Privatumo politikoje</a>."
                                }
                            ]
                        }
                    }
                }
            },
            onConsent: function (consent) {
                
                // Example: If analytics is accepted, load Google Analytics script
                if (consent.analytics) {
                    
                }
            },
            onLoad: function () {
                
            }
        });
        
    }
    
    // Initialize search type toggle
    searchTypeToggle();

    
    catalogFilter();
    watchPlToggle();
    initHeaderCategoriesSlider();
    openOffcanvasCategoriesMenu();
    offCanvasMenuOpenSubCategories();
    fixCheckoutIssues();
    
    renderOemNumbers();
    
    renderTecdocCrossReferences();
    
    onSearchShowLoader();
    
    initCookieConsent();
}

export default initPlikisGlobals;